import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { UPDATE_FACES_VALUES } from "./actionTypes";
import { updateFacesValuesSuccess, updateFacesValuesError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* updateFacesValues({ payload: { ws_pos, faces_values, token, history } }) {
  try {
    const response = yield call(workstationAPI.updateFacesValues, ws_pos, faces_values, token);
    yield put(updateFacesValuesSuccess(response.message, response.faceValues));
    history.go();
  } catch (error) {
    yield put(updateFacesValuesError(error));
  }
}

export function* watchUpdateFacesValues() {
  yield takeEvery(UPDATE_FACES_VALUES, updateFacesValues);
}

function* UpdateFacesValuesSaga() {
  yield all([fork(watchUpdateFacesValues)]);
}

export default UpdateFacesValuesSaga;
